import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { DoubleArrow, UpArrow, DownArrow } from 'ui/icons';
import { HeaderButton } from '../CampaignIndexTable.styles';

export type TableHeaderButtonProps = {
  /** Unique id for this column */
  id: string;
  /** True if column is active sort column  */
  isActiveSortColumn: boolean;
  /** True if column is sortable */
  isSortable: boolean;
  /** Label to display in column header */
  label: string;
  /** Function run when sortBy value is changed */
  onSortByChange: (newSortedById: string) => void;
  /** Function run when sort direction is changed */
  onSortDirectionChange: (sortDirection: SORT_DIRECTIONS) => void;
  /** Current sort direction */
  sortDirection: SORT_DIRECTIONS;
};

export const TableHeaderButton = ({
  id,
  isActiveSortColumn = false,
  isSortable = false,
  label,
  onSortByChange,
  onSortDirectionChange,
  sortDirection,
  ...otherProps
}: TableHeaderButtonProps) => {
  const { ASCENDING, DESCENDING } = SORT_DIRECTIONS;
  const isAscending = sortDirection === ASCENDING;
  return (
    <HeaderButton
      data-test={`column-header-${id}`}
      isActiveSortColumn={isActiveSortColumn}
      isSortable={isSortable}
      key={id}
      onClick={() => {
        if (isSortable) {
          // only respond to clicks if the header is sortable
          if (isActiveSortColumn) {
            onSortDirectionChange(isAscending ? DESCENDING : ASCENDING);
          } else {
            onSortByChange(id);
            onSortDirectionChange(DESCENDING);
          }
        }
      }}
      {...otherProps}
    >
      <span>{label}</span>
      {isSortable && !isActiveSortColumn && <DoubleArrow isColorInherited={true} />}
      {isSortable && isActiveSortColumn && isAscending && <UpArrow isColorInherited={true} />}
      {isSortable && isActiveSortColumn && !isAscending && <DownArrow isColorInherited={true} />}
    </HeaderButton>
  );
};
